import PropTypes from 'prop-types'
import styled from 'styled-components'

import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import {
  DASHBOARD_TIME_INTERVAL_SUMMARY,
  DASHBOARD_TIME_INTERVAL_1D,
  DASHBOARD_TIME_INTERVAL_2D,
  DASHBOARD_TIME_INTERVAL_7D,
  DASHBOARD_TIME_INTERVAL_30D,
} from 'constants/constants'

const StyledWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  height: 32px;
  border-bottom: 1px solid #DDDDDD;
  padding-left: 16px;
  background: #FFFFFF;
`

const TimeIntervalItem = styled.div`
  height: 100%;
  padding: 11px 16px 0 16px;
  box-sizing: border-box;
  cursor: pointer;
  color: ${colors.secondary60};
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  font-family: Exo;
  font-size: 14px;
  font-weight: normal;
  user-select: none;

  &:hover {
    color: ${colors.primary35};
  }

  &.active {
    color: ${colors.primary35};
    border-bottom: 2px solid ${colors.primary35};
    cursor: default;
    font-weight: 500;
  }
`

const TimeIntervalsPanel = ({ selectDashboardTimeInterval, dashboardSelectedTimeIntervalId }) => {
  const { t } = useTranslation()

  const dashboardTimeIntervals = [
    { id: DASHBOARD_TIME_INTERVAL_SUMMARY, name: t('dashboardPage.summaryTab') },
    { id: DASHBOARD_TIME_INTERVAL_1D, name: t('dashboardPage.last24Hours') },
    { id: DASHBOARD_TIME_INTERVAL_2D, name: t('dashboardPage.last48Hours') },
    { id: DASHBOARD_TIME_INTERVAL_7D, name: t('dashboardPage.last7Days') },
    { id: DASHBOARD_TIME_INTERVAL_30D, name: t('dashboardPage.last30Days') },
  ]

  return (
    <StyledWrapper data-test='time-intervals'>
      {dashboardTimeIntervals.map(timeInterval => {
        const timeIntervalId = timeInterval.id
        const isSelected = dashboardSelectedTimeIntervalId === timeIntervalId

        return (
          <TimeIntervalItem
            className={isSelected ? 'active' : ''}
            key={timeIntervalId}
            onClick={() => selectDashboardTimeInterval(timeInterval)}
          >
            {timeInterval.name}
          </TimeIntervalItem>
        )
      })}
    </StyledWrapper>
  )
}

TimeIntervalsPanel.propTypes = {
  selectDashboardTimeInterval: PropTypes.func.isRequired,
  dashboardSelectedTimeIntervalId: PropTypes.string.isRequired,
}

export default TimeIntervalsPanel
